export class ChatMessageName {
  static PREFIX = 'ChatMessage';

  static AUTHENTICATE = 'AUTHENTICATE';

  static RECENT_MESSAGES = 'RECENT_MESSAGES';
  static CHAT = 'CHAT';
}
